import { GameSocketState, GAME_SOCKET_INIT_STATE } from './gameSocket.state';
import * as GameSocketActions from './gameSocket.actions';
import { Action, createReducer, on } from '@ngrx/store';

const _gameSocketReducer = createReducer(

    GAME_SOCKET_INIT_STATE,

    on(
        GameSocketActions.gameSocketConnectedAction,
        (state, action) => {
            const sockets = [...state.sockets];
            const socketIndex = sockets.findIndex(sck => sck.gameStateId === action.gameStateId);
            if (socketIndex > -1 ) {
                sockets[socketIndex] = { ...sockets[socketIndex], connectionStatus: 'connected', socketId: action.socketId };
            }
            return {
                ...state,
                sockets
            };
        }
    ),

    on(
        GameSocketActions.gameSocketDisconnectedAction,
        (state, action) => {
            const sockets = [...state.sockets];
            const socketIndex = sockets.findIndex(sck => sck.gameStateId === action.gameStateId);
            if (socketIndex > -1 ) {
                sockets[socketIndex] = { ...sockets[socketIndex], connectionStatus: 'disconnected', socketId: '' }
            }
            return {
                ...state,
                sockets
            };
        }
    ),

    on(
        GameSocketActions.gameSocketCreatedAction,
        (state, action) => {
            const sockets = [...state.sockets];
            sockets.push({
                gameStateId: action.gameStateId,
                gameServerId: action.gameServerId,
                gameType: action.gameType,
                url: action.url,
                connectionStatus: 'connecting',
                socketId: '',
            })
            return {
                ...state,
                sockets
            };
        }
    ),

    on(
        GameSocketActions.betSignaledAction,
        GameSocketActions.callAnySignaledAction,
        GameSocketActions.callSignaledAction,
        GameSocketActions.checkOrFoldSignaledAction,
        GameSocketActions.checkSignaledAction,
        GameSocketActions.foldSignaledAction,
        GameSocketActions.forfeitSignaledAction,
        GameSocketActions.raiseSignaledAction,
        GameSocketActions.topUpSignaledAction,
        (state, action) => ({
            ...state,
            inputConfirmed: false,
            latestEvent: action.type,
            latestPayload: action,
        })
    ),

    on(
        GameSocketActions.dealerSignalAcceptedAction,
        (state, action) => ({
            ...state,
            inputConfirmed: true,
            messageFromDealer: action.message,
        })
    ),

    on(
        GameSocketActions.tableSignalAcceptedAction,
        (state, action) => ({
            ...state,
            inputConfirmed: true,
            messageFromDealer: action.message,
        })
    ),

    on(
        GameSocketActions.signalFailedToSendAction,
        (state, action) => ({
            ...state,
            inputConfirmed: false,
            error: action.reason,
        })
    ),

    on(
        GameSocketActions.signalRejectedAction,
        (state, action) => ({
            ...state,
            inputConfirmed: false,
            error: action.reason,
        })
    ),

    on(
        GameSocketActions.removeGameSocket,
        (state, action) => {
            const sockets = [...state.sockets].filter(socket => socket.gameStateId !== action.gameStateId);
            return {
                ...state,
                sockets,
            }
        }
    ),
)

export function gameSocketReducer(state: GameSocketState, action: Action) {
    return _gameSocketReducer(state, action);
}
